import './ThemeIcon.scss'

import React from 'react'
import {ReactComponent as Food} from '../../../assets/icons/themes/food.svg'
import {ReactComponent as Gender} from '../../../assets/icons/themes/gender.svg'
import {ReactComponent as Nature} from '../../../assets/icons/themes/nature.svg'
import {ReactComponent as Peace} from '../../../assets/icons/themes/peace.svg'
import {ReactComponent as Resources} from '../../../assets/icons/themes/resources.svg'
import {style} from '../../../util/style'

export type ThemeIconType = 'food' | 'gender' | 'nature' | 'peace' | 'resources'

const styles = style('themeicon')

export const ThemeIcon: React.FC<{
	icon: ThemeIconType
	highlighted?: boolean
}> = ({icon, highlighted}) => {
	const iconElement = getIcon(icon)
	return <span className={styles.is({highlighted})}>{iconElement}</span>
}

export const getIcon: React.FC<ThemeIconType> = (icon: ThemeIconType) => {
	switch (icon) {
		case 'food':
			return <Food />
		case 'gender':
			return <Gender />
		case 'nature':
			return <Nature />
		case 'peace':
			return <Peace />
		case 'resources':
			return <Resources />
	}
}
